module["exports"] = [
  "قرمز",
  "سبز",
  "آبی",
  "زرد",
  "بنفش",
  "فیروزه ای",
  "سفید",
  "سیاه",
  "قهوه ای",
  "نارنجی",
  "صورتی",
  "خاکستری",
  "خرمایی",
  "آبی آسمانی",
  "ارغوانی",
  "زیتونی",
  "نیلی",
  "طلایی",
  "لاجوردی",
  "نقره ای"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/commerce/color.js
// module id = 2928
// module chunks = 1610